import jobRequestService from "./../shared/services/jobRequestService";

const REQUEST_JOBREQUESTS = "REQUEST_JOBREQUESTS";
const RESPONSE_JOBREQUESTS = "RESPONSE_JOBREQUESTS";
const REQUEST_JOBREQUESTS_FAILURE = "REQUEST_JOBREQUESTS_FAILURE";

const requestJobRequestsAction = () => {
  return {
    type: REQUEST_JOBREQUESTS,
  };
};

const responseJobRequestsAction = (data) => {
  return {
    type: RESPONSE_JOBREQUESTS,
    data,
  };
};

const requestJobRequestsFailureAction = () => {
  return {
    type: REQUEST_JOBREQUESTS_FAILURE,
  };
};

const getJobRequests = () => {
  return (dispatch) => {
    dispatch(requestJobRequestsAction());

    jobRequestService
      .getJobRequests()
      .then((result) => {
        dispatch(responseJobRequestsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestJobRequestsFailureAction(error.response));
      });
  };
};

const SET_JOBREQUESTS_FILTER = "SET_JOBREQUESTS_FILTER";

const setJobRequestsFilterAction = (data) => {
  return {
    type: SET_JOBREQUESTS_FILTER,
    data,
  };
};

const setJobRequestsFilter = (filter) => {
  return (dispatch) => {
    dispatch(setJobRequestsFilterAction(filter));
  };
};

const REQUEST_CREATE_JOBREQUESTS = "REQUEST_CREATE_JOBREQUESTS";
const RESPONSE_CREATE_JOBREQUESTS = "RESPONSE_CREATE_JOBREQUESTS";
const REQUEST_CREATE_JOBREQUESTS_FAILURE = "REQUEST_CREATE_JOBREQUESTS_FAILURE";

const requestCreateJobRequestAction = () => {
  return {
    type: REQUEST_CREATE_JOBREQUESTS,
  };
};

const responseCreateJobRequestAction = (data) => {
  return {
    type: RESPONSE_CREATE_JOBREQUESTS,
    data,
  };
};

const requestCreateJobRequestFailureAction = () => {
  return {
    type: REQUEST_CREATE_JOBREQUESTS_FAILURE,
  };
};

const createJobRequest = (options) => {
  return (dispatch) => {
    dispatch(requestCreateJobRequestAction());

    jobRequestService
      .createJobRequest(options)
      .then((result) => {
        dispatch(responseCreateJobRequestAction(result.data));
      })
      .catch((error) => {
        dispatch(requestCreateJobRequestFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_JOBREQUESTS = "REQUEST_DELETE_JOBREQUESTS";
const RESPONSE_DELETE_JOBREQUESTS = "RESPONSE_DELETE_JOBREQUESTS";
const REQUEST_DELETE_JOBREQUESTS_FAILURE = "REQUEST_DELETE_JOBREQUESTS_FAILURE";

const requestDeleteJobRequestAction = () => {
  return {
    type: REQUEST_DELETE_JOBREQUESTS,
  };
};

const responseDeleteJobRequestAction = (data) => {
  return {
    type: RESPONSE_DELETE_JOBREQUESTS,
    data,
  };
};

const requestDeleteJobRequestFailureAction = () => {
  return {
    type: REQUEST_DELETE_JOBREQUESTS_FAILURE,
  };
};

const deleteJobRequest = (options) => {
  return (dispatch) => {
    dispatch(requestDeleteJobRequestAction());

    jobRequestService
      .deleteJobRequest(options)
      .then((result) => {
        dispatch(responseDeleteJobRequestAction(options));
      })
      .catch((error) => {
        dispatch(requestDeleteJobRequestFailureAction(error.response));
      });
  };
};

const SELECT_JOBREQUESTS = "SELECT_JOBREQUESTS";

const selectJobRequestAction = (data) => {
  return {
    type: SELECT_JOBREQUESTS,
    data,
  };
};

const selectJobRequest = (filter) => {
  return (dispatch) => {
    dispatch(selectJobRequestAction(filter));
  };
};

export {
  REQUEST_JOBREQUESTS,
  RESPONSE_JOBREQUESTS,
  REQUEST_JOBREQUESTS_FAILURE,
  getJobRequests,
  SET_JOBREQUESTS_FILTER,
  setJobRequestsFilter,
  REQUEST_CREATE_JOBREQUESTS,
  RESPONSE_CREATE_JOBREQUESTS,
  REQUEST_CREATE_JOBREQUESTS_FAILURE,
  createJobRequest,
  REQUEST_DELETE_JOBREQUESTS,
  RESPONSE_DELETE_JOBREQUESTS,
  REQUEST_DELETE_JOBREQUESTS_FAILURE,
  deleteJobRequest,
  SELECT_JOBREQUESTS,
  selectJobRequest,
};
